export const getWaveValuesFromAudioBuffer = (
  audioBuffer: AudioBuffer,
  numSamples = 90
): number[] => {
  const numChannels = audioBuffer.numberOfChannels

  let originalSamples: Float32Array | undefined = undefined
  if (numChannels === 2) {
    const channelDataL = audioBuffer.getChannelData(0)
    const channelDataR = audioBuffer.getChannelData(1)
    originalSamples = new Float32Array(channelDataL.length)

    for (let i = 0; i < channelDataL.length; i++) {
      // @ts-ignore
      originalSamples[i] = (channelDataL[i] + channelDataR[i]) / 2
    }
  } else {
    originalSamples = audioBuffer.getChannelData(0)
  }

  const samplesPerLine = Math.floor(originalSamples.length / numSamples)
  const rmsSamples = Array.from({ length: numSamples }, (_, i) => {
    let sumSquares = 0
    const start = i * samplesPerLine
    const end = start + samplesPerLine

    for (let j = start; j < end; j++) {
      // @ts-ignore
      sumSquares += originalSamples[j] ** 2
    }

    return samplesPerLine > 0 ? Math.sqrt(sumSquares / samplesPerLine) : 0
  })

  const maxRms = Math.max(...rmsSamples) || 1
  return rmsSamples.map((value) => value / maxRms)
}
